import React from 'react';
import {HeaderTabNavigation, MainHeader, PageWrapperLayout} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {ExamResultsTaggingEnum} from 'main/analytics/gaTagsEnum';
import {EXAMS_TABS} from './constants/examsTabs';
import {useExamResultsWrapper} from './hooks/useExamResultsWrapper';
import {StyledStack} from './styles';

const {title} = translations['pt-br'].privateFlow.examResults;

export function ExamResultsWrapper() {
	const {isMobile, theme, handleBack} = useExamResultsWrapper();

	return (
		<PageWrapperLayout title={title}>
			<MainHeader
				title={title}
				handleBack={handleBack}
				hideProfileMenu={!!isMobile}
				dataTagId={{
					backButtonRoute: ExamResultsTaggingEnum.CLICK_VOLTAR_RESULTADO_DE_EXAMES,
				}}
			/>
			<StyledStack>
				<HeaderTabNavigation
					variant={isMobile ? 'fullWidth' : 'scrollable'}
					tabs={EXAMS_TABS}
					customBackground={theme.colors.gray['10Percent']}
					customTabProps={{sx: {padding: '8px 16px'}}}
				/>
			</StyledStack>
		</PageWrapperLayout>
	);
}
